<template>
  <div>
    <div
      style="height: 255px"
      class="vuebar-element"
      v-bar="{ preventParentScroll: true, scrollThrottle: 30 }"
    >
    <div>
      <v-row
        v-for="(customer_, index) in list"
        :key="index"
        @click.stop="selectCustomer(customer_)"
        class="customers-list-row spread"
        :class="{ selected: (selected.id === customer_.id) }"
      >
        <v-col cols="1" class="radio-col">
          <v-radio-group v-model="selected_id" column>
            <v-radio
              color="amber"
              :value="customer_.id"
              class="radio-type"
              @click.stop="selectCustomer(customer_)"
            />
          </v-radio-group>
        </v-col>
        <v-col cols="11" class="results-col">
          <Card :customer="customer_" />
        </v-col>
      </v-row>
    </div>
    </div>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'

import Card from '../../templates/widget/Card'

export default {
  mixins: [ appdata ],
  components: { Card },
  props: {
    value: {
      type: Number,
      default: 0
    },
    list: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      selected_id: this.value,
      selected: {
        id: 0,
        name: '',
        phone: '',
        addresses: [],
        historic: []
      },
      editingDialog: false
    }
  },
  watch: {
    value: function (id) {
      if (id !== this.selected.id) this.selected_id = id
    },
    selected_id: function (id) {
      const list = Object.values(this.list)
      if (list && list.length) {
        const selectedObj = list.find((el) => el.id === id)
        if (selectedObj && Object.keys(selectedObj).length) {
          this.selected = Object.assign({}, selectedObj)
          this.$emit('input', id)
          this.$emit('update', Object.assign({}, this.selected))
        }
      }
    }
  },
  methods: {
    selectCustomer (customer) {
      console.log('selectCustomer', customer)
      this.selected_id = customer.id
    }
  }
}
</script>
